import React from "react";

const PersonalizationDetails = (props) => {
  return (
    <div>
      <h1>being serviced, please try again later</h1>
    </div>
  );
};

export default PersonalizationDetails;
